import { Container } from '../../../../../components'
import styled from 'styled-components'

const ExteriorScreenContainerStyled = styled(Container)`
  flex: 1 0 auto;
`

export default ExteriorScreenContainerStyled
